import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const heroRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.hero-animate').forEach((child, i) => {
              setTimeout(() => {
                (child as HTMLElement).style.opacity = '1';
                (child as HTMLElement).style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="hero"
      ref={heroRef}
      className="relative min-h-screen flex items-center pt-[64px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20atmospheric%20background%20with%20deep%20crimson%20red%20gradient%20accents%2C%20dramatic%20lighting%20with%20subtle%20texture%20pattern%2C%20mysterious%20and%20bold%20editorial%20style%2C%20dark%20warm%20tones%20with%20rich%20contrast%2C%20cinematic%20mood%2C%20no%20text%20or%20people&width=1600&height=1000&seq=hero-bg-91hl&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span
              className="hero-animate inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-accent-500/20 text-accent-300 backdrop-blur-sm mb-5"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              🔥 每日实时更新
            </span>
            <h1
              className="hero-animate font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              91黑料 — 劲爆黑料<br className="hidden sm:block" />
              视频在线观看平台
            </h1>
            <p
              className="hero-animate text-lg md:text-xl text-white/80 font-heading mb-6"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              最新黑料网站入口 · 实时更新 · 随时随地看劲爆内容
            </p>
            <p
              className="hero-animate text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              91黑料网汇聚全网最热门的娱乐圈八卦、社会热点揭秘与网红爆料视频，每日更新海量黑料内容。
              无论是最新明星塌房、主播内幕还是社会事件深挖，这里都有你想要的第一手劲爆资讯。
              本站提供最新有效的黑料网站入口与在线观看地址，确保您不错过任何精彩内容。
            </p>

            <div
              className="hero-animate flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">2000+</div>
                <div className="text-xs md:text-sm text-white/50">累计爆料视频</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">24h</div>
                <div className="text-xs md:text-sm text-white/50">全天候内容更新</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
                <div className="text-xs md:text-sm text-white/50">月活跃浏览用户</div>
              </div>
            </div>

            <div
              className="hero-animate flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
            >
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即浏览热门爆料
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full text-sm backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/15"
              >
                查看最新动态
                <i className="ri-time-line"></i>
              </a>
            </div>
          </div>

          <div
            className="hero-animate flex-1 w-full max-w-md lg:max-w-none"
            style={{ opacity: 0, transform: 'translateY(24px)', transition: 'all 0.6s ease' }}
          >
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20editorial%20composition%20with%20dark%20crimson%20and%20black%20tones%2C%20abstract%20digital%20media%20concept%20with%20glowing%20accents%2C%20mysterious%20atmosphere%2C%20bold%20contrast%20lighting%2C%20modern%20entertainment%20news%20aesthetic%2C%20no%20text%20or%20people&width=800&height=1000&seq=hero-visual-91hl&orientation=portrait"
                alt="91黑料 - 劲爆黑料视频平台主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-accent-500 animate-pulse"></div>
                  <span className="text-white/90 text-sm font-medium">实时更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#cards"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下浏览</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}